import React, { useState } from 'react';
import { Facebook, Instagram, X } from "lucide-react"; // Adicionei o X para o botão fechar
import Logo from '../images/LOGO_vermelho.svg';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();
    const [showAboutModal, setShowAboutModal] = useState(false); // Estado para controlar o Modal
    
    // Configuração do E-mail para Currículos
    const emailRH = "curriculos.ofamososalgados@gmail.com"; // <--- COLOQUE SEU EMAIL AQUI
    const assuntoEmail = "Envio de Currículo - Candidato";

    const scrollToStores = (e) => {
        if(e) e.preventDefault();
        
        if (window.location.pathname !== '/') {
             navigate('/');
             setTimeout(() => {
                const element = document.getElementById('lojas');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
             }, 100);
        } else {
             const element = document.getElementById('lojas');
             if (element) {
                 element.scrollIntoView({ behavior: 'smooth' });
             }
        }
    };

    // Função para abrir o Sobre Nós
    const openAbout = (e) => {
        e.preventDefault();
        setShowAboutModal(true);
    };

  return (
    <>
        <footer className="bg-[#FFC300] text-[#E63312] pt-20 pb-10 relative">
        <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-3 gap-12 mb-12">
                
                {/* Brand */}
                <div className="flex flex-col items-start gap-4">
                    <div className="h-20 w-20 flex items-center justify-center mb-2">
                        <img 
                            src={Logo} 
                            alt="O Famoso" 
                            className="w-full h-auto"
                        />
                    </div>
                    <h3 className="text-2xl font-black uppercase">O FAMOSO</h3>
                    <p className="font-medium text-[#E63312]/80 max-w-xs leading-relaxed">
                        Do salgado ao doce, da coxinha ao mini-churros, nenhuma festa é a mesma sem O Famoso.
                    </p>
                    <div className="flex gap-4 mt-6">
                        <a href="https://www.facebook.com/salgadosofamoso" target="_blank" rel="noreferrer" className="bg-[#E63312] text-[#FFC300] p-3 rounded-full hover:bg-black hover:text-white transition-all transform hover:scale-110">
                            <Facebook className="w-6 h-6" />
                        </a>
                        <a href="https://www.instagram.com/ofamososalgado/" target="_blank" rel="noreferrer" className="bg-[#E63312] text-[#FFC300] p-3 rounded-full hover:bg-black hover:text-white transition-all transform hover:scale-110">
                            <Instagram className="w-6 h-6" />
                        </a>
                    </div>
                </div>

                {/* Quick Links / Locations List */}
                <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-12">
                    <div>
                        <a 
                            href="#lojas" 
                            onClick={scrollToStores}
                            className="font-black text-xl mb-6 text-[#E63312] uppercase tracking-wide border-b-2 border-[#E63312] pb-2 inline-block cursor-pointer hover:text-black hover:border-black transition-colors"
                        >
                            Encontre uma Loja
                        </a>
                        
                        <ul className="space-y-3 font-semibold">
                            <li className="flex items-start group">
                                <span className="w-2 h-2 bg-[#E63312] rounded-full mt-2 mr-3 group-hover:bg-black transition-colors"></span>
                                <a href="#lojas" onClick={scrollToStores} className="hover:text-black hover:underline transition-all cursor-pointer">
                                    Manoel de Vasconcelos - Sumaré
                                </a>
                            </li>
                            <li className="flex items-start group">
                                <span className="w-2 h-2 bg-[#E63312] rounded-full mt-2 mr-3 group-hover:bg-black transition-colors"></span>
                                <a href="#lojas" onClick={scrollToStores} className="hover:text-black hover:underline transition-all cursor-pointer">
                                    Av. Rebouças - Sumaré
                                </a>
                            </li>
                            <li className="flex items-start group">
                                <span className="w-2 h-2 bg-[#E63312] rounded-full mt-2 mr-3 group-hover:bg-black transition-colors"></span>
                                <a href="#lojas" onClick={scrollToStores} className="hover:text-black hover:underline transition-all cursor-pointer">
                                    Matão - Sumaré
                                </a>
                            </li>
                            <li className="flex items-start group">
                                <span className="w-2 h-2 bg-[#E63312] rounded-full mt-2 mr-3 group-hover:bg-black transition-colors"></span>
                                <a href="#lojas" onClick={scrollToStores} className="hover:text-black hover:underline transition-all cursor-pointer">
                                    Resid. Bordon - Sumaré
                                </a>
                            </li>
                            <li className="flex items-start group">
                                <span className="w-2 h-2 bg-[#E63312] rounded-full mt-2 mr-3 group-hover:bg-black transition-colors"></span>
                                <a href="#lojas" onClick={scrollToStores} className="hover:text-black hover:underline transition-all cursor-pointer">
                                    Lot. Remanso Campineiro - Hortolândia
                                </a>
                            </li>
                            <li className="flex items-start group">
                                <span className="w-2 h-2 bg-[#E63312] rounded-full mt-2 mr-3 group-hover:bg-black transition-colors"></span>
                                <a href="#lojas" onClick={scrollToStores} className="hover:text-black hover:underline transition-all cursor-pointer">
                                    Jd. Metonópolis - Campinas
                                </a>
                            </li>
                        </ul>
                    </div>
                    
                    <div>
                        <h4 className="font-black text-xl mb-6 text-[#E63312] uppercase tracking-wide border-b-2 border-[#E63312] pb-2 inline-block">Institucional</h4>
                        <ul className="space-y-3 font-semibold">
                            <li>
                                <a href="#" onClick={openAbout} className="hover:text-black hover:underline transition-all">
                                    Sobre nós
                                </a>
                            </li>
                            <li>
                                {/* Link mailto para abrir o email direto */}
                                <a 
                                    href={`mailto:${emailRH}?subject=${encodeURIComponent(assuntoEmail)}`}
                                    className="hover:text-black hover:underline transition-all"
                                >
                                    Trabalhe conosco
                                </a>
                            </li>
                            <li>
                                <button onClick={() => navigate('/tabela-nutricional')} className="hover:text-black hover:underline transition-all bg-transparent border-none cursor-pointer text-left p-0 font-semibold text-[#E63312] hover:text-black">
                                    Informações Nutricionais
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div className="border-t border-[#E63312]/20 pt-8 text-center text-sm font-semibold">
                <p>&copy; 2013 O Famoso. Todos os direitos reservados.</p>
            </div>
        </div>
        </footer>

        {/* MODAL SOBRE NÓS */}
        {showAboutModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200">
                <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden relative border-4 border-[#FFC300]">
                    
                    {/* Botão Fechar */}
                    <button 
                        onClick={() => setShowAboutModal(false)}
                        className="absolute top-4 right-4 text-gray-400 hover:text-[#E63312] transition-colors bg-gray-100 rounded-full p-1"
                    >
                        <X size={24} />
                    </button>

                    <div className="p-8">
                        <h3 className="text-3xl font-black text-[#E63312] uppercase mb-6 border-b-4 border-[#FFC300] inline-block pb-2">
                            Nossa História
                        </h3>
                        
                        <div className="space-y-4 text-gray-700 leading-relaxed text-lg">
                            <p>
                                Tudo começou com uma receita de família e uma missão simples: <strong>transformar a fome em felicidade.</strong>
                            </p>
                            <p>
                                O Famoso nasceu da paixão por fazer salgados de verdade — crocantes por fora, super recheados por dentro e com aquele tempero caseiro que abraça a gente.
                            </p>
                            <p>
                                Hoje, somos referência na região de Campinas e Sumaré, levando sabor para festas, reuniões e para aquele lanche da tarde imperdível.
                            </p>
                            <p className="font-bold text-[#E63312]">
                                O Famoso: Pequeno no tamanho, gigante no sabor!
                            </p>
                        </div>

                        <div className="mt-8">
                            <button 
                                onClick={() => setShowAboutModal(false)}
                                className="w-full bg-[#E63312] text-white font-bold py-3 px-6 rounded-full uppercase tracking-wider hover:bg-[#FFC300] hover:text-[#E63312] transition-colors"
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )}
    </>
  );
};

export default Footer;